import React from 'react';

const ReturnsPage = () => {
  return (
    <div className="max-w-screen-xl mx-auto px-4 py-6 md:py-10 w-full">
      <div className="mb-6 md:mb-8">
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3 md:mb-4">Возврат товара</h1>
        <h2 className="text-lg md:text-xl font-semibold text-gray-800 mb-4 md:mb-6">ПОЛОЖЕНИЕ О ВОЗВРАТЕ ТОВАРА</h2>
      </div>

      <div className="space-y-6 md:space-y-8">
        {/* Общие условия */}
        <div className="rounded-lg border border-gray-200 p-4 md:p-6">
          <h3 className="text-base md:text-lg font-semibold text-gray-900 mt-2 mb-3">Общие условия</h3>
          <div className="space-y-3 text-sm md:text-base text-gray-700">
            <p>
              <strong>1.1.</strong> Возврат Товара, поставленного Поставщиком в рамках настоящего Договора, допускается в случаях и порядке, предусмотренных Договором и настоящим Положением.
            </p>
            <p>
              <strong>1.2.</strong> Возврат Товара должен быть оформлен через сайт parallel.one. Возврат Товара надлежащего качества, оформленный другим способом, не рассматривается и не принимается Поставщиком.
            </p>
          </div>
        </div>

        {/* Отказ от приемки Товара */}
        <div className="rounded-lg border border-gray-200 p-4 md:p-6">
          <h3 className="text-base md:text-lg font-semibold text-gray-900 mt-2 mb-3">Отказ от приемки Товара</h3>
          <div className="space-y-3 text-sm md:text-base text-gray-700">
            <p>
              <strong>2.1.</strong> Приемка Товара по качеству в части видимых недостатков и целостности, и соответствия упаковки при доставке товара Поставщиком осуществляется на складе Покупателя, а при самовывозе Покупателем/Перевозчиком Покупателя на складе Поставщика в момент получения товара от Поставщика.
            </p>
            <p>
              <strong>2.2.</strong> В случае обнаружения в момент приемки некачественного Товара в части видимых недостатков Покупатель вправе отказаться от его приемки с составлением соответствующего Акта об установленном расхождении по количеству и/или качеству при приемке Товара либо принять Товар, имеющий недостатки по качеству, но в дальнейшем лишается возможности предъявления претензии по качеству принятого Товара.
            </p>
            <p>
              <strong>2.3.</strong> Поставщик вправе не принимать отказ Покупателя от приемки Товара, в случае если видимый дефект незначительный, не влияет на качественные показатели деталей, и не влечёт дополнительных расходов при установке на автомобиль:
            </p>
            <ul className="list-disc list-inside ml-4 space-y-2">
              <li>царапины, потёртости, шероховатости на транспортировочном грунте, для деталей под покраску;</li>
              <li>дефекты деталей, которые после установки на автомобиль будут скрыты от визуального просмотра;</li>
              <li>незначительная деформация деталей из мягкого пластика, устранимая при установке или сборке детали;</li>
              <li>замятие сот, царапины, вмятины на радиаторе, не влияющие на теплообменные свойства и герметичность;</li>
              <li>царапины, потёртости, вмятины на глушителях, трубах, резонаторах, не влияющие на работоспособность деталей.</li>
            </ul>
            <p>
              <strong>2.4.</strong> Товар всех категорий в виде крепежных элементов, некоторых видов уплотнений не подлежит маркировке производителями и поставляется без упаковки и какой-либо иной идентификации производителя, но при этом соответствует своему назначению.
            </p>
          </div>
        </div>

        {/* Условия возврата Товара */}
        <div className="rounded-lg border border-gray-200 p-4 md:p-6">
          <h3 className="text-base md:text-lg font-semibold text-gray-900 mt-2 mb-3">Условия возврата Товара</h3>
          <div className="space-y-4 text-sm md:text-base text-gray-700">
            <p>
              <strong>3.1.</strong> Товары, входящие в комплект как его составные части, возврату или обмену подлежат только в составе комплекта.
            </p>
            
            <div className="space-y-3">
              <h4 className="font-semibold text-gray-800">3.2. Возврат Товара надлежащего качества</h4>
              <p>
                <strong>3.2.1.</strong> Возврат Товара надлежащего качества допускается только по согласованию с Поставщиком и не позднее 14 (Четырнадцати) календарных дней с момента поставки Товара Покупателю.
              </p>
              <p>
                <strong>3.2.2.</strong> Возврат Товара надлежащего качества возможен только в случае сохранения целостности и чистоты упаковки и Товара, а также наличия штрих-кода parallel.one на упаковке, либо непосредственно на самом Товаре.
              </p>
            </div>

            <div className="space-y-3">
              <h4 className="font-semibold text-gray-800">3.3. Возврат Товара ненадлежащего качества</h4>
              <p>
                <strong>3.3.1.</strong> Претензии по качеству Товара подлежат рассмотрению Поставщиком в случае наличия штрих-кода parallel.one на упаковке, либо непосредственно на самом Товаре. Поставщик оставляет за собой право отказать в удовлетворении претензии Покупателя в случае отсутствия штрих-кода parallel.one.
              </p>
              <p>
                <strong>3.3.2.</strong> Запросы на возврат по Товару ненадлежащего качества, недостаток которого был выявлен в процессе установки, принимается в обработку после предоставления Покупателем документов, подтверждающих установку автозапчасти в СТО, а также документов, подтверждающих наличие заводского дефекта.
              </p>
              <p>
                <strong>3.3.3.</strong> В случаях предъявления Покупателем Поставщику претензии по качеству Товара (в том числе по Товару с признаками контрафактности) Поставщик оставляет за собой право требовать передачи (возврата) ему указанного в претензии Товара (в том числе для проведения экспертизы) и отказать в удовлетворении претензии Покупателя в случае, если Товар не передан.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReturnsPage;
